export default __webpack_public_path__ + "static/media/calendar.3612e68f.svg";